module.exports = __webpack_public_path__ + "img/levelup-logout-black.ac764614.svg";